import React from "react";
import { Button } from "antd";
import { RollbackOutlined } from "@ant-design/icons";

const PageHeader = ({ onBack, title, breadcrumb, extra }) => {
  const items = breadcrumb && breadcrumb.length > 0 ? breadcrumb : null;

  return (
    <div className="npl-card-header">
      {onBack && (
        <Button
          icon={<RollbackOutlined />}
          className="npl-btn-secondary"
          onClick={onBack}
        >
          Retour
        </Button>
      )}
      {items ? (
        <nav className="npl-breadcrumb">
          {items.map((item, i) => {
            const isLast = i === items.length - 1;
            return (
              <React.Fragment key={i}>
                {i > 0 && <span className="npl-breadcrumb-sep">›</span>}
                {isLast ? (
                  <b className="npl-breadcrumb-current">{item.label}</b>
                ) : item.onClick ? (
                  <button
                    type="button"
                    className="npl-breadcrumb-link"
                    onClick={item.onClick}
                  >
                    {item.label}
                  </button>
                ) : (
                  <span className="npl-breadcrumb-text">{item.label}</span>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      ) : (
        title && (
          <span className="npl-section-title" style={{ marginBottom: 0 }}>
            {title}
          </span>
        )
      )}
      {extra && <span className="npl-card-header-extra">{extra}</span>}
    </div>
  );
};

export default PageHeader;